module.exports = __webpack_public_path__ + "img/battery_gray2.ee8b2390.png";